import React from 'react'
import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import WebProject from './WebProject'
import Footer from '../LandingPage/Footer'
import AboutPostHeader from '../ContactUs/AboutPostHeader'
const WebService = () => {
  const data = [
    // {
    //   img: '/amazon.PNG',
    //   web: 'Amazon Clone',
    //   class: 'web-pic',
    //   webLink: 'https://www.youtube.com/watch?v=MUxC75B_oiA',
    // },
    // {
    //   img: '/youtube.PNG',
    //   web: 'Youtube Clone',
    //   class: 'web-pic',
    //   webLink: 'https://www.youtube.com/watch?v=Z309FPaETMw',
    // },
    {
      img: '/club.PNG',
      web: 'Billionare Club',
      class: 'web-pic',
      webLink: 'https://fir-appy-16aa8.web.app/',
    },
    {
      img: '/Capture1.PNG',
      web: 'Smart Games',
      class: 'web-pic',
      webLink: 'https://smartgame-fb46e.web.app/',
    },
    {
      img: '/tech.PNG',
      web: 'Technosoft Codex',
      class: 'web-pic',
      webLink: 'https://techcode-d39a0.web.app/',
    },
 

    {
      img: '/Capture.jpg',
      web: 'Parlay Betting Exchange',
      class: 'web-pic',
      webLink: 'https://parlay-18c45.web.app/',
    },
    {
      img: '/portfolio.PNG',
      web: 'Technosoft Codex Portfolio',
      class: 'web-pic',
      webLink: 'https://tokens-b8a17.web.app/',
    },
    {
      img: '/Capture2.PNG',
      web: 'World Eggs Club',
      class: 'web-pic',
      webLink: 'https://monstermob-b6c12.web.app/',
    },
    {
      img: '/twoMpixel.PNG',
      web: 'TwoMPixels',
      class: 'web-pic',
      webLink: 'https://technosoft-c2316.web.app/',
    },


    {
      img: '/kom.PNG',
      web: 'Kommunitas',
      class: 'web-pic',
      webLink: 'https://heroic-vial-259010.web.app/',
    },

    {
      img: '/sakiswap.PNG',
      web: 'SakiSwap',
      class: 'web-pic',
      webLink: 'https://sakiswap.web.app/',
    },    {
      img: '/ghost.PNG',
      web: 'GhostCards',
      class: 'web-pic',
      webLink: 'https://tikiswap.web.app/',
    },
  
    {
      img: '/figma.PNG',
      web: 'Figma',
      class: 'web-pic',
      webLink: 'https://fir-appy-16aa8.web.app/',
    },
  ]
  var dataArray = data.map((section) => {
    return (
      <WebProject
        img={section.img}
        web={section.web}
        class={section.class}
        webLink={section.webLink}
      />
    )
  })
  const contact = {
    head: "  Some Recent Projects I Deliver",
    para:'My Satisfaction is to deliver quality!'
  };
  return (
    <div>
      <Header />
      <Navbar />
    <AboutPostHeader obj={contact} />

      <div className="container mt-5">
        
        <div className="row">{dataArray}</div>

      </div>
      <Footer />
    </div>
  )
}

export default WebService
